export function getDecodedSign(symbol) {
  const decodedSign = (symbol == null ? void 0 : symbol.replace(/&#(\d+);/g, function (_, dec) {
    return String.fromCharCode(dec);
  })) ?? '$';
  return decodedSign.includes('$') ? '$' : decodedSign;
}
//# sourceMappingURL=decode-sign.js.map